import { TenantComment } from "@models";
import { useStore } from "@stores";
import { useCallback, useEffect } from "react";

export interface CommentsHook {
  comments: TenantComment[];
  loading: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  loadMore: () => void;
}

export const useComments = (tenantId: number, open: boolean): CommentsHook => {
  const { tenantStore } = useStore();
  const {
    comments,
    commentsLoading: loading,
    commentsLoadingMore: loadingMore,
    commentsTotalCount,
    commentsMaxResultCount,
  } = tenantStore;

  useEffect(() => {
    return () => tenantStore.clearComments();
  }, [tenantStore]);

  useEffect(() => {
    if (open) {
      tenantStore.getComments(tenantId, 0, commentsMaxResultCount, false);
    }
  }, [open, tenantStore, tenantId, commentsMaxResultCount]);

  const hasMore = comments.length < commentsTotalCount;

  const loadMore = useCallback(() => {
    tenantStore.getComments(tenantId, comments.length, commentsMaxResultCount, true);
  }, [tenantStore, tenantId, comments.length, commentsMaxResultCount]);

  return { comments, loading, loadingMore, hasMore, loadMore };
};
